import React, { useCallback, useEffect, useRef, useState } from "react";
import { get_events } from "../Services/apiRoutes";
import { CircularProgress, Grid, Box, Typography, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import EventsCard from "./EventsCard";
import { getCryptoLogoMap } from "../utils/utility";

let coinSymbol = [];

export default function Events() {
    const [loading, setLoading] = useState(true);
    const [iconURL, setIconURL] = useState();
    const [events, setEvents] = useState([]);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [dates, setDates] = useState(["Any Date"]);
    const [selectedDate, setSelectedDate] = useState('Any Date');

    const isFetched = useRef(false);

    const fetchEvents = async () => {
        try {
            const data = await get_events();
            pushCoins(data["data"]);
            getCoinData();
            const sortedEvents = data["data"].sort((a, b) => new Date(b.date) - new Date(a.date));
            setEvents(sortedEvents);
            setFilteredEvents(sortedEvents);
            extractDates(sortedEvents);
        } catch (error) {
            console.log("Error fetching events", error);
        } finally {
            setLoading(false);
        }
    };

    const extractDates = (data) => {
        const uniqueDates = new Set(["Any Date"]);
        data.forEach(item => {
            const formattedDate = new Date(item.date).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
            uniqueDates.add(formattedDate);
        });
        setDates(Array.from(uniqueDates));
    };

    const getCoinData = async () => {
        var result = await getCryptoLogoMap(coinSymbol);
        setIconURL(result);
        return result;
    };

    const pushCoins = (dataArray) => {
        dataArray.forEach((data) => {
            coinSymbol.push(data["coinsUsed"]);
        });
    };

    const handleDateChange = (event) => {
        const selectedDate = event.target.value;
        setSelectedDate(selectedDate);

        // Filter events based on selected date
        if (selectedDate === 'Any Date') {
            setFilteredEvents(events); // Reset to all events
        } else {
            const filtered = events.filter(item => item.start_date.includes(selectedDate));
            setFilteredEvents(filtered);
        }
    };

    useEffect(() => {
        if (!isFetched.current) {
            fetchEvents();
            isFetched.current = true;
        }
    }, []);

    return (
        <Box maxWidth="1300px" position="relative" margin="auto">
            <Box
                display="flex"
                justifyContent="center"
                alignItems={"center"}
                sx={{
                    position: "relative",
                }}
            >
                <Typography sx={{ fontWeight: "bold", textAlign: "center", marginTop: "10px", marginBottom: "30px" }} variant="h4">
                    Auro Events
                </Typography>
            </Box>
            <Box display="flex" justifyContent="end" alignItems={"center"} sx={{ marginBottom: "20px" }}>

                <FormControl variant="outlined" sx={{ minWidth: 120 }}>
                    <Select value={selectedDate} onChange={handleDateChange}>
                        {dates.map((date, index) => (
                            <MenuItem key={index} value={date}>
                                {date}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            <div style={{ minHeight: "100px", marginTop: "40px", display: "flex" }}>
                {loading ? (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "50px", marginLeft: "auto", marginRight: "auto" }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <Grid container spacing={4}>
                        {filteredEvents.map((item) => (
                            <Grid item xs={12} sm={6} md={4} key={item.id}>
                                <EventsCard
                                    event_name={item.event_name}
                                    content={item.content}
                                    coinsUsed={item.coinsUsed}
                                    hashtags={item.hashtags}
                                    likes={item.likes}
                                    views={item.views}
                                    image_url={item.image_url}
                                    url={item.url}
                                    country={item.country}
                                    icons={iconURL}
                                    startDate={item.start_date}
                                    endDate={item.end_date}
                                />
                            </Grid>
                        ))}
                    </Grid>
                )}
            </div>
        </Box>
    );
}
